import { Button } from "@/components/ui/button";
import { PlusCircle, Menu } from "lucide-react";

interface ChatHeaderProps {
  onNewChat: () => void;
  onToggleSidebar: () => void;
  isMobile: boolean;
  showSidebar: boolean;
}

export const ChatHeader = ({ 
  onNewChat, 
  onToggleSidebar, 
  isMobile, 
  showSidebar 
}: ChatHeaderProps) => {
  return (
    <div className="border-b p-4 flex justify-between items-center">
      {isMobile && (
        <Button 
          variant="ghost" 
          size="icon"
          onClick={onToggleSidebar}
          className="mr-2"
        >
          <Menu className="h-5 w-5" />
        </Button>
      )}
      <h2 className="text-lg font-semibold">Chat</h2>
      <Button 
        variant="outline" 
        onClick={onNewChat}
        className="gap-2"
      >
        <PlusCircle className="h-4 w-4" />
        New Chat
      </Button>
    </div>
  );
};